<template>
<div>
    <a-popconfirm :placement="placement" icon=" " v-model:visible="popVisible" :showCancel="false">
        <template #okButton></template>
        <template #title>
            <div class="userInfo">
                <div class="userInfo-top">
                    <div class="ava">
                        <a-avatar :size="46" :src="user.member.member.headPortrait==null?'':user.member.member.headPortrait" class="userAvatar">
                            {{user.member.member.headPortrait==null?user.realName.charAt(0):''}}
                        </a-avatar>
                        <img class="vipImg" v-if="menberType!=3" :src="require(menberType==1?'@/assets/Image/userInfo/svip.png':'@/assets/Image/userInfo/vip.png')" alt="">
                    </div>
                    <div class="user">
                        <div>
                            <div class="name">
                                <!-- <ellipsis></ellipsis> -->
                                <ellipsis width="37" num="1" :content="user.member.member.nickname" textStyle="display:block"></ellipsis>
                            </div>
                            <!-- <img v-if="user.openMember.length!=0" :src="require('@/assets/Image/popover/member.png')" alt="" srcset=""> -->
                            <img v-if="user.openMember.length!=0" :src="user.openMember[0].icon" alt="" srcset="">
                            <div class="clear"></div>
                        </div>
                        <div class="money">余额：{{user.account.accountMoney.toLocaleString('zh-CN', {style: 'currency', currency: 'CNY',})}}</div>
                    </div>
                    <div class="date">
                        <div v-if="user.openMember.length!=0">有效期止:{{user.openMember[0].expiryDate.split('-')[0]}}年{{user.openMember[0].expiryDate.split('-')[1]}}月{{user.openMember[0].expiryDate.split('-')[2]}}日</div>
                        <div style="margin-top:5px">
                            <a-button v-if="user.openMember.length!=0" @click="openRenew(user.openMember[0])">续费</a-button>
                            <a-button v-else @click="openRenew">会员</a-button>
                            <a-button style="margin-left:6px" @click="openPay">充值</a-button>
                        </div>
                    </div>
                </div>
                <div class="menu">
                    <div class="menu-item" @click="tolink('/user/userInfo')">
                        <img :src="require('@/assets/Image/popover/settings.png')" alt=""> 个人设置
                    </div>
                    <!-- <div class="menu-item" @click="openInviteUser">
                        <img :src="require('@/assets/Image/popover/invite.png')" alt=""> 邀请成员
                    </div> -->
                    <div class="menu-item" @click="openDownLoad">
                        <img :src="require('@/assets/Image/popover/client.png')" alt=""> 客户端下载
                    </div>
                    <div class="menu-item" @click="loginOut">
                        <img :src="require('@/assets/Image/popover/logout.png')" alt=""> 退出登录
                    </div>
                </div>
            </div>
        </template>
        <div class="avatarWrap">
            <slot name="avatar"></slot>
            <div class="avatarHoverCard" v-show="!popVisible">
                <div class="hover-user">
                    <div class="hover-ava">
                        <a-avatar :size="46" :src="user.member.member.headPortrait==null?'':user.member.member.headPortrait" class="hover-avatar">
                            {{user.member.member.headPortrait==null?user.realName.charAt(0):''}}
                        </a-avatar>
                        <img class="hover-vip" v-if="menberType!=3" :src="require(menberType==1?'@/assets/Image/userInfo/svip.png':'@/assets/Image/userInfo/vip.png')" alt="">
                    </div>
                    <div class="hover-info">
                        <div class="hover-name">
                            <span class="hover-name-text">{{user.member.employees.employeesName}}</span>
                            <img v-if="user.openMember.length!=0" class="hover-member-icon" :src="user.openMember[0].icon" alt="">
                        </div>
                        <div class="hover-row"><span class="hover-label">当前企业</span>{{user.member.enterprise.enterpriseName}}</div>
                        <div class="hover-row"><span class="hover-label">会员类型</span>{{memberTypeText}}</div>
                        <div class="hover-row"><span class="hover-label">会员有效期</span>{{memberExpiryText}}</div>
                    </div>
                </div>
            </div>
        </div>
    </a-popconfirm>
    <renew v-model:visible="visible" :renewActive="renewActive"></renew>
    <!-- <business v-model:visible="busVisible"></business> -->
    <!-- <addBusiness v-model:visible="addBusVisible"></addBusiness> -->
    <recharge v-model:visible="payVisible"></recharge>
    <coupon v-model:visible="couponVisible"></coupon>
    <downLoad v-model:visible="downLoadVisible"></downLoad>
    <inviteUser v-model:visible="inviteUserVisible"></inviteUser>
    <newCoupon v-model:visible="newCouponVisible"></newCoupon>
</div>
</template>
<script>
import renew from '@/components/renew'
import recharge from '@/components/recharge'
import downLoad from '@/components/downLoad'
import inviteUser from '@/components/inviteUser'
import coupon from '@/components/renew/components/coupon'
import newCoupon from '@/components/newCoupon'
import {list} from '../../mixins/list'
import { mapGetters, mapActions } from "vuex";
import Cookies from 'js-cookie'
import { getCouponList, } from '@/api/coupon'
import { notification } from 'ant-design-vue';
export default {
    mixins:[list],
    components: {
        renew,recharge,coupon,newCoupon,downLoad,inviteUser
    },
    props:{
        placement:{
            type: String,
            default:'bottomRight'
        },
        menberType:{
            type: Number,
            default:3
        }
    },
    data(){
        return{
            visible: false,
            busVisible: false,
            popVisible:false,
            payVisible:false,
            addBusVisible:false,
            couponVisible:false,
            newCouponVisible:false,
            downLoadVisible:false,
            inviteUserVisible:false,
            renewActive:'',
        }
    },
    created(){
        // this.isEStatus()
        this.isTips()
        this.isNewUser()
        if(this.$route.query.redirect==='1'){
            this.openPay()
        }
    },
    methods:{
        ...mapActions(['LogOut']),
        //当前登录企业是否已禁用
        // isEStatus(){
        //     if(this.user.member.employees==null){
        //         this.$message.warning('账号架构数据异常，请联系管理员！')
        //         return;
        //     };
        //     console.log(this.user.member.employees)
        //     if(this.user.member.employees&&this.user.member.employees.status==-1){
        //         this.$message.warning('该企业权限已被禁用，请切换企业！')
        //         this.openBus()
        //         return;
        //     }
        // },
        //新用户优惠券领取弹窗
        isNewUser(){
            if(this.user.member.member.lastLoginTime==null){
                this.newCouponVisible = true
                return;
            }
        },
        //优惠券每日提醒
        async isTips(){
            let tipsTime = Cookies.get('Tips-Time')
            if(!tipsTime||tipsTime!=new Date().toLocaleDateString()){
                let coupon = await getCouponList({})
                coupon = coupon.data
                if(coupon.filter(item => item.canUse==1&&item.expire==0).length>0){
                    Cookies.set('Tips-Time', new Date().toLocaleDateString())
                    notification.warning({
                        message: '系统通知',
                        description:
                        '您有一张优惠券未使用，请尽快使用！',
                    });
                }
            }
        },
        // 打开续费弹窗
        openRenew(item){
            if(item){
                this.renewActive = item.memberTypeNo
            }else{
                this.renewActive = ''
            }
            this.popVisible=false
            this.visible=true
        },
        // 打开切换企业弹窗
        openBus(){
            this.popVisible=false
            this.busVisible=true
        },
        // 打开添加企业弹窗
        openAddBus(){
            this.popVisible=false
            this.addBusVisible=true
        },
        // 打开充值弹窗
        openPay(){
            this.popVisible=false
            this.payVisible=true
        },
        openDownLoad(){
            this.popVisible=false
            this.downLoadVisible=true
        },
        openInviteUser(){
            this.popVisible=false
            this.inviteUserVisible=true
        },
        // 退出
        loginOut(){
          this.LogOut().then(() => {
            this.$message.success('已退出')
            this.tolink('/login')
          })
        }
    },
    computed:{
        ...mapGetters(["user"]),
        //是否是当前企业的管理员
        isOwnerOrManager(){
            return this.user.userlName == this.user.member.enterprise.owner||this.user.userlName == this.user.member.enterprise.manager
        },
        //当前有效的会员（超级会员优先）
        currentMember(){
            const list = this.user.openMember || []
            const valid = list.filter(m => m.expiryDate && new Date(m.expiryDate).getTime() > Date.now())
            if(!valid.length) return null
            return valid.find(m => m.isvvip === 1) || valid[0]
        },
        //会员类型
        memberTypeText(){
            const m = this.currentMember
            if(!m) return '未开通'
            return m.memberTypeName || (m.isvvip === 1 ? '超级会员' : '会员')
        },
        //会员有效期
        memberExpiryText(){
            const m = this.currentMember
            if(!m) return '未开通'
            const parts = m.expiryDate.split('-')
            return `${parts[0]}年${parts[1]}月${parts[2]}日`
        },
    }
}
</script>
<style lang="less" scoped>

.userInfo{
    margin-left: -42px;
    margin-top: -16px;
    margin-bottom: -36px;
    margin-right: -20px;
    min-width: 335px;
    min-height: 320px;
    // border: 1px solid #f2f3f5;
    border-radius: 10px;
    box-shadow: 0px 4px 10.56px 0.48px rgba(216,216,216,0.40); 
    background-color: #ffffff;
    &-top{
        background: url("../../assets/Image/userInfo.png") no-repeat;
        background-size:100% 100%;
        height: 90px;
        padding: 22px 0px;
        padding-left: 8px;
        padding-right: 15px;
        font-size: 12px;
        color: #ffffff;
        .userAvatar{
            float: left;
            cursor: pointer;
        }
        .user{
            float: left;
            margin-left: 8px;
            .name{
                font-size: 16px;
                line-height: 24px;
                float: left;
            }
            img{
                width: 24px;
                height: 24px;
                margin-left: 11px;
                float: left;
            }
            .money{
                margin-top: 5px;
            }
        }
        .date{
            float: right;
            margin-left: 28px;
        }
    }
}
.popover-list{
    // padding: 5px;
    .popover-item{
        width: 132px;
        line-height: 44px;
        border-radius: 4px;
        color: #333333;
        cursor: pointer !important;
        img{
            width: 20px;
            height: 20px;
            margin-top: 12px;
            margin-left: 15px;
            margin-right: 12px;
            float: left;
        }
        &:hover{
            background: #eff4ff;
        }
    }
}
.menu{
    padding: 20px;
    margin-bottom: 8px;
    .menu-item{
        line-height: 44px;
        border-radius: 4px;
        color: #333333;
        cursor: pointer !important;
        margin-bottom: 7px;
        img{
            width: 20px;
            height: 20px;
            margin-top: 12px;
            margin-left: 15px;
            margin-right: 12px;
            border-radius: 50%;
            float: left;
        }
        &:hover{
            background: #eff4ff;
        }
    }
}
.ava{
    position: relative;
    width: 46px;
    height: 46px;
    float: left;
    .vipImg{
        position: absolute;
        width: 46px;
        height: 19.5px;
        left: 1px;
        bottom: -5.5px;
    }
}
.clear{
    clear: both;
}
.avatarWrap{
    float: right;
    position: relative;
    height: 55px;
    .avatarHoverCard{
        display: none;
        position: absolute;
        top: 100%;
        right: 12px;
        z-index: 100;
        min-width: 250px;
        padding: 18px 20px;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 4px 10.56px 0.48px rgba(216,216,216,0.40);
        font-size: 12px;
        color: #333333;
        line-height: 22px;
        .hover-user{
            display: flex;
            align-items: flex-start;
            .hover-ava{
                position: relative;
                width: 46px;
                height: 46px;
                flex-shrink: 0;
                margin-right: 12px;
                .hover-vip{
                    position: absolute;
                    width: 46px;
                    height: 19.5px;
                    left: 0px;
                    bottom: -5.5px;
                }
            }
            .hover-info{
                flex: 1;
                min-width: 0;
                .hover-name{
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 24px;
                    margin-bottom: 4px;
                    .hover-name-text{
                        display: inline-block;
                        max-width: 130px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        vertical-align: middle;
                    }
                    .hover-member-icon{
                        width: 24px;
                        height: 24px;
                        margin-left: 6px;
                        vertical-align: middle;
                    }
                }
                .hover-row{
                    white-space: nowrap;
                    .hover-label{
                        margin-right: 6px;
                        color: #999999;
                    }
                }
            }
        }
    }
    &:hover .avatarHoverCard{
        display: block;
    }
}
</style>